/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Catalog_Movement_Chest_FlyInputs */

const en_us2_catalog_movement_chest_fly = /** @type {(inputs: Catalog_Movement_Chest_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`chest fly`)
};

const pt_br2_catalog_movement_chest_fly = /** @type {(inputs: Catalog_Movement_Chest_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`crucifixo`)
};

const es_419_catalog_movement_chest_fly = /** @type {(inputs: Catalog_Movement_Chest_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aperturas`)
};

const pt_pt2_catalog_movement_chest_fly = /** @type {(inputs: Catalog_Movement_Chest_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aberturas`)
};

const fr_fr2_catalog_movement_chest_fly = /** @type {(inputs: Catalog_Movement_Chest_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`écarté`)
};

const de_de2_catalog_movement_chest_fly = /** @type {(inputs: Catalog_Movement_Chest_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fliegende`)
};

const it_it2_catalog_movement_chest_fly = /** @type {(inputs: Catalog_Movement_Chest_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`croci`)
};

/**
* | output |
* | --- |
* | "chest fly" |
*
* @param {Catalog_Movement_Chest_FlyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const catalog_movement_chest_fly = /** @type {((inputs?: Catalog_Movement_Chest_FlyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Catalog_Movement_Chest_FlyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_catalog_movement_chest_fly(inputs)
	if (locale === "es-419") return es_419_catalog_movement_chest_fly(inputs)
	if (locale === "pt-PT") return pt_pt2_catalog_movement_chest_fly(inputs)
	if (locale === "fr-FR") return fr_fr2_catalog_movement_chest_fly(inputs)
	if (locale === "de-DE") return de_de2_catalog_movement_chest_fly(inputs)
	if (locale === "it-IT") return it_it2_catalog_movement_chest_fly(inputs)
	return en_us2_catalog_movement_chest_fly(inputs)
});
export { catalog_movement_chest_fly as "catalog.movement.chest_fly" }